<app-dialog
	modalTitle="Confirmar exclusão"
	titleButton="Excluir"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	[noMargins]="true"
	[asAlert]="true"
	(dialogClose)="closeModal()"
	(dialogSave)="confirm()"
>
	<div class="d-f fd-c mt-xxs mb-xxs">
		<p class="lh-md">
			Tem certeza que deseja excluir permanentemente a organização
			<span class="fw-bold">
				{{
					data.organization.name_economic_group ||
						data.organization.name_secondary
				}}?
			</span>
		</p>

		<p class="fs-xs gray mt-xxs italic gray">Esta ação é irreversível</p>
	</div>
</app-dialog>
